if (customElements.get('pagination-collection-ajax')) {
  console.warn('pagination-collection-ajax is already defined');
} else {
  class PaginationCollectionAjax extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.destroy();
    }

    destroy() {
      // Clean up any resources or event listeners
    }

    loading(isLoading) {
        const loadingClass = 'collection-custom-filter-loading';
        let loadingDom = document.querySelector(`.${loadingClass}`);
        const bodyDom = document.querySelector('body');

        if (isLoading) {
            if (!loadingDom) {
                loadingDom = document.createElement('div');
                loadingDom.className = loadingClass;
                loadingDom.innerHTML = '<div class="spinner loading__spinner"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" width="16" height="16"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg></div>';
                bodyDom.appendChild(loadingDom);
            }
            
            loadingDom.classList.add('active');
        } else if (!isLoading && loadingDom) {
            loadingDom.classList.remove('active');
        }
        
    }

    handleClick(event) {
      const link = event.target.closest('a');
      if (!link) return;

      event.preventDefault();
      const url = new URL(link.href);
      url.searchParams.set('view', 'ajax');

      this.loading(true);

      fetch(url.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text();
        })
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('pagination-collection-ajax').innerHTML;
            this.innerHTML = newContent;
            const newProductGrid = doc.querySelector('#product-grid');
            const currentProductGrid = document.querySelector('#product-grid');

            if (currentProductGrid && newProductGrid) {
                currentProductGrid.innerHTML = newProductGrid.innerHTML;

                // scroll to top of product grid
                currentProductGrid.scrollIntoView({ behavior: 'smooth' });
            }

            window.history.pushState({}, '', link.href);
        })
        .catch((error) => {
          console.error('There was a problem with the fetch operation:', error);
        })
        .finally(() => {
          this.loading(false);
        });
    }
  }

  customElements.define('pagination-collection-ajax', PaginationCollectionAjax);
}